module.exports = __webpack_public_path__ + "img/reward.33f53404.svg";